import { external as externalScript } from '../../utils/script'

function loadAmplitudeScript() {
  externalScript.load({
    name: 'amplitude',
    loadNow: true,
  })
}

export function initTheDuelExternalScripts() {
  loadAmplitudeScript()
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/initTheDuelExternalScripts.js